import { fromEvent, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Consent } from './consent.model';
export namespace CookieInformation {

    export function consent(category: string): Observable<boolean> {
        return fromEvent(window, 'CookieInformationConsentGiven').pipe(
            map(() => window['cicc'] ? window['cicc'][`cookie_cat_${category}`] : false),
            startWith(window['cicc'] ? window['cicc'][`cookie_cat_${category}`] : false)
        );
    }
    export function cookieConsentFactory(): Consent {
        var langSplit = (document?.body?.parentElement?.lang ?? 'da-dk').split('-');
        var lang = langSplit[0]
        const script = document.createElement('script');
        script.id = 'CookieConsent';
        script.src = 'https://policy.app.cookieinformation.com/uc.js';
        script.setAttribute('data-culture', lang.toUpperCase());
        script.type = 'text/javascript';
        script.setAttribute("data-gcm-version", "2.0");
        document.head.append(script);
        return new Consent(consent('necessary'), consent('statistic'), consent('marketing'), consent('functional'));
    }
}




